module.exports = __webpack_public_path__ + "img/BookPay.5b50d400.svg";